import React from 'react';
import { motion } from 'framer-motion';
import { Trans } from 'react-i18next';
import { UserGroupIcon } from '@heroicons/react/24/outline';
import { team } from '../data/team';

const TeamSection: React.FC = () => {
  return (
    <section id="team" className="py-20 bg-secondary-light dark:bg-secondary-dark relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-4">
            <Trans>team.title</Trans>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 text-lg">
            <Trans>team.subtitle</Trans>
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {team.map((member, idx) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: idx * 0.1 }}
              className="bg-white/50 dark:bg-black/50 backdrop-blur-sm p-8 rounded-xl shadow-lg text-center hover:-translate-y-2 hover:bg-white/60 dark:hover:bg-black/60 transition-transform duration-300"
            >
              <div className="w-24 h-24 bg-accent/20 rounded-full mx-auto mb-4 flex items-center justify-center transition-all duration-300 hover:rotate-12 hover:scale-105">
                <UserGroupIcon className="h-12 w-12 text-accent" />
              </div>
              <h3 className="text-xl font-semibold mb-2">
                <Trans>{`team.${member.name}`}</Trans> {member.country}
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                <Trans>{`team.${member.role}`}</Trans>
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
